<template>
    <div class="tryoutIndexPage flex">
       <aside class="asideView">
           <h3 :class="nowActiveTitle == '0'&&'activeTitle'" @click="changeNav('0')">账号设置</h3>
           <div>
                <div class="secTitle" :class="nowActiveTitle == '1'&&'activeTitle'" @click="changeNav('1')">基本资料</div>
                <!-- <div class="secTitle" :class="nowActiveTitle == '2'&&'activeTitle'" @click="changeNav('2')">实名认证</div> -->
           </div>
       </aside>
        <!-- v-loading="loading" -->
       <section class="tryoutContent">
           <!-- 基本资料 -->
           <div v-if="nowActiveTitle == '0'||nowActiveTitle == '1'" class="baseData">
               <div>用户名称：<span>{{userInfoData.user.phone}}</span></div>
               <div>手机号码：<span>{{userInfoData.user.phone}}</span></div>
           </div>
       </section>
    </div>
</template>

<script>
// import axios from 'axios'
import {getCookiesData} from '../../../utils/common'
export default {
name: 'UserinfoIndex',
    data() {
        return {
            // loading: true,
            nowActiveTitle: '1', // 左侧菜单
            nowActiveHeaderAuth: '2', // 实名认证类型0未认证 1 企业 2个人
            nowAuthStatus: '0', // 实名认证状态// 0未认证 1 正在审核中 2未通过 3 通过
            surePerBtnLoading: false, // 个人提交认证按钮加载状态
            gainAPIBtnLoading: false, // 获取API key的按钮加载状态
            warningView: false, // 获取API提示的警告信息弹框显示与否
            userInfoData: {}, // 用户信息
            perRules: {
                name: [{ required: true, message: '请输入个人姓名', trigger: 'blur' },],
                reason: [{ required: true, message: '请输入申请理由', trigger: 'blur' },]
            }
        };
    },
    created() {
        this.$emit('isNavClick', '')
        this.$actionBuryPointWay('','user-info-page','open','')
        this.nowActiveTitle = this.$route.query.leftActiveTitle?this.$route.query.leftActiveTitle: '1'
        this.dealData()
    },
    mounted() {},
    methods: {
        dealData () {
            this.userInfoData = getCookiesData('skyCodeUserBaseInfo')?JSON.parse(getCookiesData('skyCodeUserBaseInfo')): {}
            // // auth_status// 是否认证： 1、无 未认证 2 个人认证流程 3企业认证流程
            // // 根据不同状态存储查看用户是什么流程，是否有实名认证数据
            // // 目前改为：如果不是1，证明已经认证成功，1表示未认证或失败；
            // console.log(this.userInfoData.user.auth_status)
            // switch (this.userInfoData.user.auth_status) {
            //     case 1:
            //         this.loading = false
            //         break
            //     default:
            //         this.loading = false
            //         this.nowAuthStatus = '3' // 实名认证已通过
            //         break
            // }
        },
        // async getCertificationData(type){
        //     let that = this
        //     console.log(type)
            
        //     that.loading = false
        // },
        // onInput() {
        //     this.$forceUpdate();
        // },
        // changeNav(val) {
        //     console.log(val)
        //     this.nowActiveTitle = val
        //     if (val == '3'&&this.userInfoData.user.app_key) { // api菜单且有值
        //          this.APIKeyStatus = '2'
        //     }
        // },
        // jumpTryoutIndexPage () {
        //     this.$router.push({path: '/tryoutIndex'})
        // },
        // async gainAPIBtn () {
        //     let that = this
        //     that.gainAPIBtnLoading = true
        //     let res = await that.$get(that.$axiosUrl.userAppKey, {})
        //     console.log(res)
        //     that.gainAPIBtnLoading = false
        //     if (res.resp_data.auth_status == 2) { // 已实名认证
        //         that.userInfoData.user.app_key = res.resp_data.app_key
        //         that.userInfoData.user.app_secret = res.resp_data.app_secret
        //         that.$forceUpdate()
        //         // that.$store.dispatch('GetBaseInfo', that.userInfoData)

        //         that.$nextTick(()=>{
        //             if (that.$route.query.pathName) {
        //                 that.$router.push({path: '/' + that.$route.query.pathName, replace: true})
        //             }
        //         })
        //     } else { // 未实名认证
        //         that.warningView = true
        //         setTimeout(function () { that.warningView = false }, 3000)
        //     }
        // },
        // certiSubmitBtn(formName, status){
        //     let that = this
        //     console.log(status);
        //     that.$refs[formName].validate((valid) => {
        //         if (valid) {
        //             that.surePerBtnLoading = true
        //             var submitData = {name: that.userInfoData.user.name, phone: that.userInfoData.user.phone, reason: that.userInfoData.user.reason}
        //             console.log(submitData)
        //             that.$jsonPost(that.$axiosUrl.certificationPer, submitData)
        //             .then((res)=>{
        //                 console.log(res)
        //                 that.surePerBtnLoading = false
        //                 that.userInfoData.user.app_key = res.resp_data.app_key
        //                 that.userInfoData.user.app_secret = res.resp_data.app_secret
        //                 that.userInfoData.user.auth_status = res.resp_data.auth_status
        //                 that.$store.dispatch('GetBaseInfo', that.userInfoData)
        //                 // 审核成功返回appkey serset; 失败提示失败
        //                 that.$nextTick(()=>{
        //                     if (that.$route.query.pathName) {
        //                         that.$router.push({path: '/' + that.$route.query.pathName, replace: true})
        //                     }
        //                 })
        //             })
        //             .catch((err)=>{console.log(err), that.surePerBtnLoading = false})
        //         } else {
        //             console.log('error submit!!');
        //             return false;
        //         }
        //     });
        // },
    }
};
</script>

<style scoped lang="less">
    .tryoutIndexPage {
        width: 100%;
        height: 100vh;
        padding-top: 117px;
        background: #060714;
        border-top: 1px solid rgba(38, 40, 64, 0.5);
        .asideView {
            // width: 594px;
            width: 30.9375vw;
            border-right: 1px solid rgba(38, 40, 64, 0.9);
            padding: 60px 130px 0 0;
            text-align: right;
            h3 {
                font-weight: 700;
                font-size: 18px;
                margin-bottom: 30px;
                color: #fff;
                cursor: pointer;
                padding-right: 32px;
            }
            .secTitle {
                color: rgba(255, 255, 255, 0.7);
                cursor: pointer;
            }
            .activeTitle {
                color: #544FFF !important;
            }
        }
        .tryoutContent {
            flex: 1;
            min-width: 815px;
            overflow-y: auto;
            .baseData {
                padding: 111px 0 0 129px;
                font-size: 20px;
                div {
                    margin-bottom: 48px;
                    color: #fff;
                }
            }
        }
    }
</style>
